module.exports = __webpack_public_path__ + "static/media/cq_messaggi_s.a2f6c53c.svg";